import { render } from "./BgImg.vue?vue&type=template&id=74c25566&scoped=true"
import script from "./BgImg.vue?vue&type=script&lang=js"
export * from "./BgImg.vue?vue&type=script&lang=js"

import "./BgImg.vue?vue&type=style&index=0&id=74c25566&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74c25566"]])

export default __exports__